import useToken from '@/auth/core/useToken'
import axios from '@axios'

const { auth } = new useToken(axios, {})
export default auth
